import { render, staticRenderFns } from "./OrderSourceTable.vue?vue&type=template&id=e2fce12e&scoped=true&"
import script from "./OrderSourceTable.vue?vue&type=script&lang=ts&"
export * from "./OrderSourceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fce12e",
  null
  
)

/* custom blocks */
import block0 from "./OrderSourceTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports